import MessengerContainer from "containers/MessengerContainer";
import FullScreenMessenger from "components/Chat/FullScreenMessenger";

export default MessengerContainer(FullScreenMessenger);
